var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82315 4.95904V14.1434C5.82315 15.0152 5.82315 15.4508 6.01121 15.7838C6.17664 16.0767 6.44042 16.3154 6.76509 16.4646C7.13383 16.6341 7.61679 16.6341 8.58126 16.6341H13.418C14.3824 16.6341 14.8647 16.6341 15.2334 16.4646C15.5581 16.3154 15.8228 16.0767 15.9882 15.7838C16.1761 15.4512 16.1761 15.0159 16.1761 14.1458V4.95904M5.82315 4.95904H7.54864M5.82315 4.95904H4.09766M7.54864 4.95904H14.4506M7.54864 4.95904C7.54864 4.23372 7.54864 3.87124 7.67998 3.58516C7.85511 3.20373 8.19079 2.90051 8.61359 2.74252C8.93068 2.62402 9.33289 2.62402 10.1369 2.62402H11.8624C12.6663 2.62402 13.0683 2.62402 13.3854 2.74252C13.8082 2.90051 14.144 3.20373 14.3192 3.58516C14.4505 3.87124 14.4506 4.23372 14.4506 4.95904M14.4506 4.95904H16.1761M16.1761 4.95904H17.9016",
    stroke: "#EF4343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashEmpty);
export default __webpack_public_path__ + "static/media/Trash_Empty.172cf8074b9ed720576abf047aa77a49.svg";
export { ForwardRef as ReactComponent };